import axios from "axios";

const getApiUrl = () => {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1" || host.includes("preview.emergentagent.com")) {
      return process.env.REACT_APP_BACKEND_URL || "";
    }
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL || "";
};

export const API_URL = getApiUrl();

// Global: always send cookies
axios.defaults.withCredentials = true;

// Auto-refresh interceptor for expired tokens
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error) => {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) reject(error);
    else resolve();
  });
  failedQueue = [];
};

const SKIP_REFRESH_URLS = ["/auth/login", "/auth/refresh", "/auth/me", "/auth/logout"];

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const url = originalRequest?.url || "";

    // Skip refresh for auth endpoints and already-retried requests
    const shouldSkip = SKIP_REFRESH_URLS.some((path) => url.includes(path));
    if (error.response?.status !== 401 || originalRequest._retry || shouldSkip) {
      return Promise.reject(error);
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      }).then(() => axios(originalRequest));
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      await axios.post(`${API_URL}/api/auth/refresh`);
      processQueue(null);
      return axios(originalRequest);
    } catch (refreshError) {
      processQueue(refreshError);
      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  }
);
